/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    landingPageTypeFormId: {
        fr_FR: "dqT9HNLd",
        en_US: "QcIhUGPb",
        it_IT: "IncTCiKP",
    },
};
